export const AFFILIATORS_RESET_STATE = 'AFFILIATORS_RESET_STATE';
export const AFFILIATORS_CURRENT_ITEM = 'AFFILIATORS_CURRENT_ITEM';

export const AFFILIATORS_REQUEST_LOADING = 'AFFILIATORS_REQUEST_LOADING';
export const AFFILIATORS_REQUEST_SUCCESS = 'AFFILIATORS_REQUEST_SUCCESS';
export const AFFILIATORS_REQUEST_FAILED = 'AFFILIATORS_REQUEST_FAILED';

export const AFFILIATORS_CURRENT_ACTION = 'AFFILIATORS_CURRENT_ACTION';
export const AFFILIATORS_RESET_ACTION = 'AFFILIATORS_RESET_ACTION';